import React from 'react'

export default function Info() {
  return (
    <div className="about__info grid">
        <div className="about__box">
            <i className=" bx bx-award about__icon"></i>

            <h3 className="about__title">Experience</h3>
            <span className='about__subtitle'>2 years working</span>
        </div>
           <div className="about__box about__icon">
            <i className=" bx bx-briefcase-alt"></i>

            <h3 className="about__title">Completed</h3>
            <span className='about__subtitle'>12+ Projects</span>
        </div> 
           <div className="about__box">
            <i className=" bx bx-support about__icon"></i>

            <h3 className="about__title">Support</h3>
            <span className='about__subtitle'>Online 12/7</span>
        </div>

    </div>
  )
}
